import ActionLink from 'components/ActionLink';
import Attachments, { IFilePath } from 'components/Attachments';
import { fetchFilesSilently } from 'components/Attachments/utils';
import ContentItem from 'components/Website/ContentItem';
import HorizontalLine from 'components/Website/HorizontalLine';
import PageTitle from 'components/Website/PageTitle';
import SiteContent from 'components/Website/SiteContent';
import useAuth from 'hooks/useAuth';
import useCommon from 'hooks/useCommon';
import useFetchResource from 'hooks/useFetchResource';
import api from 'libs/api';
import React, { FunctionComponent, useMemo } from 'react';

interface IPublicDocument {
  file: IFilePath;
  title: string;
}

const documentFile = ({ file, title }: IPublicDocument): IFilePath => ({
  ...file,
  name: title,
});

const fetchDocumentFiles = () =>
  fetchFilesSilently(api.website.documents.getAll(), (data: { resources: IPublicDocument[] }) =>
    data.resources.map(documentFile)
  );

const NewsSpecific: FunctionComponent = () => {
  const { title: commonTitle } = useCommon();
  const { isAuthorized } = useAuth();
  const { resource } = useFetchResource<IPublicDocument[]>({
    api: api.website.documents.getAll,
    initialValues: [],
    serializer: (data) => data.resources,
  });

  const documents = useMemo(() => resource.map(documentFile), [resource]);

  return (
    <SiteContent>
      {isAuthorized && (
        <>
          <ContentItem>
            <PageTitle>Private Documents</PageTitle>
          </ContentItem>
          <ContentItem>
            <HorizontalLine />
          </ContentItem>
          <ContentItem>
            <p>
              <ActionLink to="/documents?archive=active">Go to the Dashboard</ActionLink> to view
              all the Documents available for residents of {commonTitle}
            </p>
          </ContentItem>
        </>
      )}
      <ContentItem>
        <PageTitle className="mt0">Public Documents</PageTitle>
      </ContentItem>
      <ContentItem>
        <HorizontalLine />
      </ContentItem>
      <ContentItem>
        <Attachments files={documents} fetchFiles={fetchDocumentFiles} />
      </ContentItem>
    </SiteContent>
  );
};

export default NewsSpecific;
